export default __webpack_public_path__ + "static/media/PeugeotNew-Regular.0e7f7cac.otf";